module.exports = __webpack_public_path__ + "img/trends_2.5de48ea1.jpg";